import { Box, Button, Paper, Stack, Typography, Link as MuiLink } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useEffect, useState, useContext, useCallback } from "react";
import { ThemeContext } from '../../context/ThemeContext';
import { FaLink } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { resetQuickAccess, manageQuickAccessApi } from "../../store/quick-access/manageQuickAccess";
import DataGridComponent from "../../components/DataGridComponent";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import { useNavigate } from "react-router-dom";
import DeleteQuickAccess from "./DeleteQuickAccess";

export default function ManageQuickAccess() {
  const manageQuickAccess = useSelector((state) => state?.manageQuickAccess);
  const { result, loading, total } = manageQuickAccess;
  const { paginationModel, setPaginationModel } = useContext(ThemeContext);
  const navigate = useNavigate();

  const [queryOptions, setQueryOptions] = useState({});
  const [currentQuery, setCurrentQuery] = useState({});
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteKey, setDeleteKey] = useState("");

  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);

  const dispatch = useDispatch();

  const columns = [
    {
      field: "order",
      headerName: "Order",
      minWidth: 100,
      flex: 0.5,
      filterable: false,
      sortable: false,
    },
    // {
    //   field: "id",
    //   headerName: "ID",
    //   minWidth: 80,
    //   flex: 0.5,
    //   filterable: false,
    //   sortable: false,
    // },
    {
      field: "image",
      headerName: "Icon",
      minWidth: 100,
      flex: 0.5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          {params.row.image ? <img src={params.row.image} alt={params.row.title} style={{ width: 40, height: 40, objectFit: 'contain' }} /> : "-"}
        </Box>
      ),
    },
    // {
    //   field: "key",
    //   headerName: "Key",
    //   minWidth: 150,
    //   flex: 1,
    //   filterable: false,
    //   sortable: false,
    // },
    {
      field: "title",
      headerName: "Title",
      minWidth: 150,
      flex: 1,
      filterable: false,
      sortable: false,
    },
    {
      field: "title_hi",
      headerName: "Title (Hindi)",
      minWidth: 150,
      flex: 1,
      filterable: false,
      sortable: false,
    },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   minWidth: 250,
    //   flex: 2,
    //   filterable: false,
    //   sortable: false,
    // },
    // {
    //   field: "description_hi",
    //   headerName: "Description (Hindi)",
    //   minWidth: 250,
    //   flex: 2,
    //   filterable: false,
    //   sortable: false,
    // },
    {
      field: "route",
      headerName: "Route",
      minWidth: 150,
      flex: 1,
      filterable: false,
      sortable: false,
    },
    {
      field: "is_active",
      headerName: "Active",
      minWidth: 100,
      flex: 0.5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography variant="body2" color={params.row.is_active ? 'success.main' : 'error.main'}>
          {params.row.is_active ? 'Yes' : 'No'}
        </Typography>
      ),
    },
    {
      field: "is_default",
      headerName: "Default",
      minWidth: 100,
      flex: 0.5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography variant="body2" color={params.row.is_default ? 'success.main' : 'error.main'}>
          {params.row.is_default ? 'Yes' : 'No'}
        </Typography>
      ),
    },
    {
      field: "pinned_users_count",
      headerName: "Pinned Users",
      minWidth: 130,
      flex: 0.8,
      filterable: false,
      sortable: false,
    },
    {
      field: "update_link",
      headerName: "Edit",
      minWidth: 130,
      flex: 0.8,
      filterable: false,
      sortable: false,
      disableExport: true,
      renderCell: (params) => (
        <Button
          color="info"
          variant="outlined"
          endIcon={<EditIcon />}
          onClick={() => navigate(`/quick-access/edit/${params.row.id}`)}
        >
          Edit
        </Button>
      ),
    },
    {
      field: "delete_link",
      headerName: "Delete",
      minWidth: 130,
      flex: 0.8,
      filterable: false,
      sortable: false,
      disableExport: true,
      renderCell: (params) => (
        <Button
          color="error"
          variant="outlined"
          endIcon={<DeleteOutlineIcon />}
          style={{ marginLeft: "5px" }}
          onClick={() => {
            setDeleteId(params.row.id);
            setDeleteKey(params.row.key);
            setDeleteOpen(true);
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  useEffect(() => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;
    const searchValue = firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || "";

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      value: searchValue,
      search: searchValue,
    };
    setCurrentQuery(query);
    dispatch(manageQuickAccessApi(query));
  }, [dispatch, queryOptions, paginationModel]);

  useEffect(() => {
    return () => {
      dispatch(resetQuickAccess());
    };
  }, [dispatch]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <FaLink size={24} />
          <Typography variant="h6" fontWeight={600}>Quick Access Links</Typography>
        </Stack>

        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              onClick={() => navigate("/quick-access/add")}
            >
              Add New Link
            </Button>
          </Stack>
        </Stack>

        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              });
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
              height: 500
            }}
            getRowId={(row) => row.id}
            rows={result || []}
            columns={columns}
            onFilterModelChange={onFilterChange}
            disableColumnFilter
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                CustomGridToolbar({
                  ...props,
                  hasfilter: false,
                  hasExport: false,
                  hasSearch: true,
                  queryOptions: queryOptions,
                  paginationModel: paginationModel,
                }),
            }}
            slotProps={{
              loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'linear-progress',
              },
            }}
          />
        </Paper>
      </Body>
      <DeleteQuickAccess open={deleteOpen} setOpen={setDeleteOpen} id={deleteId} query={currentQuery} itemKey={deleteKey} />
    </>
  );
}
